import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faUser, faTachometerAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../../auth/AuthContext';
import './Navigation.css';

const MobileMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { auth, logout } = useContext(AuthContext);
    
    const toggleMenu = () => {
        setIsOpen(!isOpen);
        // Prevent scrolling when menu is open
        document.body.style.overflow = isOpen ? 'auto' : 'hidden';
    };
    
    const closeMenu = () => {
        setIsOpen(false);
        document.body.style.overflow = 'auto';
    };
    
    const handleLogout = () => {
        logout();
        closeMenu();
    };
    
    return (
        <>
            <div className="mobile-menu-container">
                <div className="mobile-menu-inner">
                    <Link to="/" className="nav-title-link">
                        <h1>Connexierge</h1>
                    </Link>
                    
                    <div className="mobile-buttons">
                        {auth && (
                            <div 
                                className={`account-icon-mobile ${auth ? 'logged-in' : ''}`}
                                onClick={() => setIsOpen(true)}
                            >
                                <FontAwesomeIcon icon={faUser} />
                            </div>
                        )}
                        
                        {!auth && (
                            <button 
                                className="hamburger-button"
                                onClick={() => setIsOpen(true)}
                                aria-label="Open menu"
                            >
                                <FontAwesomeIcon icon={faBars} />
                            </button>
                        )}
                    </div>
                </div>
            </div>
            
            {isOpen && (
                <div className="mobile-menu-overlay">
                    <div className="mobile-menu">
                        <div className="mobile-menu-header">
                            <h2>Connexierge</h2>
                            <button 
                                className="close-menu-button" 
                                onClick={closeMenu}
                                aria-label="Close menu"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        
                        <ul className="mobile-nav-links">
                            <li>
                                <Link to="/" onClick={closeMenu}>Home</Link>
                            </li>
                            <li>
                                <Link to="/buyers" onClick={closeMenu}>Buyers</Link>
                            </li>
                            <li>
                                <Link to="/sellers" onClick={closeMenu}>Sellers</Link>
                            </li>
                            
                            {auth ? (
                                <>
                                    <li>
                                        <Link to="/profile" onClick={closeMenu}>
                                            <FontAwesomeIcon icon={faUser} /> Profile
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/dashboard" onClick={closeMenu}>
                                            <FontAwesomeIcon icon={faTachometerAlt} /> Dashboard
                                        </Link>
                                    </li>
                                    <li>
                                        <button 
                                            className="mobile-logout-button"
                                            onClick={handleLogout}
                                        >
                                            <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                                        </button>
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li>
                                        <Link to="/register" onClick={closeMenu}>Register</Link>
                                    </li>
                                    <li>
                                        <Link to="/login" onClick={closeMenu}>Login</Link>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};

export default MobileMenu; 